module.exports = __webpack_public_path__ + "static/media/buy_req_make_2.659754ad.jpg";